<!-- En la cabecera del mapa no van los tipos de sensor (AT32, RG22…): ya salen en la leyenda "Entradas" -->
<ng-container *ngIf="showChrome; else mapBody">
  <div class="dashboard-widget-card">
    <app-widget-card-header
      [title]="widget.title"
      [isMockPreview]="isMockPreview"
      [isEditable]="isEditable"
      [canDelete]="canDelete"
      [isEditMode]="isEditMode"
      [sensorTypeLabels]="[]"
      (edit)="edit.emit()"
      (remove)="remove.emit()">
    </app-widget-card-header>

    <div class="dashboard-widget-card__content">
      <ng-container *ngTemplateOutlet="mapBody"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #mapBody>
  <div class="widget-map">

    <!-- Vista previa del formulario: sin llamada al servidor -->
    <div class="widget-map__message" *ngIf="isPreview">
      <mat-icon>map</mat-icon>
      <span>El mapa mostrará los dispositivos y el contorno que añadas en Entradas</span>
    </div>

    <ng-container *ngIf="!isPreview">
      <div class="widget-map__message" *ngIf="loading">
        <mat-spinner diameter="28"></mat-spinner>
      </div>

      <div class="widget-map__message" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <span>No se ha podido cargar el mapa</span>
      </div>

      <!-- Plantilla del admin: no hay un área real. Sí se ve lo configurado (leyenda "Entradas", solo para ver) -->
      <ng-container *ngIf="data && !data.hasInstance">
        <div class="widget-map__message">
          <mat-icon>map</mat-icon>
          <span>El mapa se verá en el dashboard de cada área</span>
        </div>
        <div class="widget-map__layers" *ngIf="data.polygonLegend?.length || variables.length">
          <button type="button" class="widget-map__layers-head" [attr.aria-expanded]="legendOpen" (click)="toggleLegend()">
            <span>Entradas</span>
            <mat-icon>{{ legendOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="widget-map__layers-body" *ngIf="legendOpen">
            <div class="widget-map__layer widget-map__layer--readonly" *ngFor="let polygon of data.polygonLegend">
              <i class="widget-map__swatch widget-map__swatch--polygon"></i>
              <span class="widget-map__layer-text">
                <span>{{ polygon.label }}</span>
                <small>Propiedad del área</small>
              </span>
            </div>
            <div class="widget-map__layer widget-map__layer--readonly" *ngFor="let variable of variables; trackBy: trackById">
              <i class="widget-map__swatch" [style.background]="variableColor(variable)"></i>
              <span class="widget-map__layer-text">
                <span>{{ variableLabel(variable) }}</span>
                <small>{{ variableSource(variable) }}</small>
              </span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Sin nada que pintar: o no hay entradas, o solo el contorno y no se encuentra (sin dibujar o mal configurado) -->
      <div class="widget-map__message" *ngIf="data?.hasInstance && !hasContent">
        <mat-icon>{{ polygonNotice ? 'polyline' : 'location_off' }}</mat-icon>
        <span>{{ polygonNotice ?? 'Añade entradas al widget para ver dispositivos o el contorno del área' }}</span>
      </div>

      <ng-container *ngIf="data?.hasInstance && hasContent">
        <div #mapCanvas class="widget-map__canvas"></div>

        <!-- Leyenda: mostrar u ocultar sin cambiar la configuración del widget (no se guarda) -->
        <div class="widget-map__layers">
          <button type="button" class="widget-map__layers-head" [attr.aria-expanded]="legendOpen" (click)="toggleLegend()">
            <span>Entradas</span>
            <mat-icon>{{ legendOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="widget-map__layers-body" *ngIf="legendOpen">
            <!-- Polígonos sin regla (formato anterior): una línea, como antes -->
            <label class="widget-map__layer" *ngIf="hasPlainPolygons">
              <input type="checkbox" [checked]="polygonVisible" (change)="togglePolygon()">
              <i class="widget-map__swatch widget-map__swatch--polygon"></i>
              <span class="widget-map__layer-text">
                <span>{{ polygonLegendLabel }}</span>
                <small>Propiedad del área</small>
              </span>
            </label>
            <!-- Reglas de polígono: el nombre de la propiedad y debajo sus áreas, cada una con su color (se pliega) -->
            <div class="widget-map__group" *ngFor="let group of polygonGroups; trackBy: trackByGroup">
              <div class="widget-map__layer widget-map__group-head">
                <input type="checkbox" [checked]="isGroupVisible(group)" (change)="toggleGroup(group)">
                <button type="button" class="widget-map__group-toggle" [attr.aria-expanded]="isGroupOpen(group)" (click)="toggleGroupOpen(group)">
                  <span class="widget-map__layer-text">
                    <span>{{ group.label }}</span>
                    <small>Propiedad del área</small>
                  </span>
                  <mat-icon>{{ isGroupOpen(group) ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </div>
              <ng-container *ngIf="isGroupOpen(group)">
                <label class="widget-map__layer widget-map__layer--area" *ngFor="let area of group.areas; trackBy: trackByArea">
                  <input type="checkbox" [checked]="isAreaVisible(area.key)" (change)="toggleArea(area.key)">
                  <i class="widget-map__swatch widget-map__swatch--polygon" [style.border-color]="area.color" [style.background]="area.color + '22'"></i>
                  <span class="widget-map__layer-text"><span>{{ area.name }}</span></span>
                </label>
              </ng-container>
            </div>
            <!-- Debajo del nombre, de dónde viene la entrada (variable del admin o de un manual) -->
            <label class="widget-map__layer" *ngFor="let variable of variables; trackBy: trackById">
              <input type="checkbox" [checked]="isVariableVisible(variable.id)" (change)="toggleVariable(variable.id)">
              <i class="widget-map__swatch" [style.background]="variableColor(variable)"></i>
              <span class="widget-map__layer-text">
                <span>{{ variableLabel(variable) }}</span>
                <small>{{ variableSource(variable) }}</small>
              </span>
            </label>
          </div>
        </div>

        <!-- Con dispositivos pero sin el polígono del área: se ven, y se avisa de que falta el contorno -->
        <div class="widget-map__notice" *ngIf="polygonNotice && !polygonNoticeClosed" role="status">
          <mat-icon>info</mat-icon>
          <span>{{ polygonNotice }}</span>
          <button type="button" class="widget-map__notice-close" aria-label="Cerrar aviso" title="Cerrar"
            (click)="closePolygonNotice()">×</button>
        </div>

        <!-- Lo que no se pinta en el mapa: fuera del contorno (el mapa no se aleja) y sin ubicación.
             Puntos de izquierda a derecha; el nombre al pasar el ratón y la ficha al pulsar. -->
        <div class="widget-map__tray" *ngIf="shownOutside.length || shownWithoutLocation.length">
          <ng-container *ngIf="shownOutside.length">
            <span class="widget-map__tray-title">Fuera del área ({{ shownOutside.length }})</span>
            <div class="widget-map__tray-points">
              <button type="button" *ngFor="let device of shownOutside; trackBy: trackById" class="widget-map__tray-point"
                [style.background]="deviceColor(device.status)" [matTooltip]="displayName(device)"
                [attr.aria-label]="displayName(device)" (click)="select(device)"></button>
            </div>
          </ng-container>
          <ng-container *ngIf="shownWithoutLocation.length">
            <span class="widget-map__tray-title">Sin ubicación ({{ shownWithoutLocation.length }})</span>
            <div class="widget-map__tray-points">
              <button type="button" *ngFor="let device of shownWithoutLocation; trackBy: trackById" class="widget-map__tray-nolocation"
                [style.color]="deviceColor(device.status)" [matTooltip]="displayName(device) + ' · sin ubicación'"
                [attr.aria-label]="displayName(device) + ', sin ubicación'" (click)="select(device)">
                <mat-icon>location_off</mat-icon>
              </button>
            </div>
          </ng-container>
        </div>

        <!-- Ficha del dispositivo -->
        <aside class="widget-map__detail" *ngIf="selected as device">
          <header class="widget-map__detail-head">
            <div>
              <h3>{{ displayName(device) }}</h3>
              <p>
                {{ device.sensors.length }} {{ device.sensors.length === 1 ? 'sensor' : 'sensores' }}
                · {{ device.lastDate ? 'última lectura ' + ago(device.lastDate) : 'sin datos' }}
                <ng-container *ngIf="batteryLabel(device) as battery"> · batería {{ battery }}</ng-container>
              </p>
              <!-- Solo el estado de este dispositivo (mismo color que su chincheta), no la leyenda de todos -->
              <p>
                <span class="widget-map__status" [style.--c]="deviceColor(device.status)">
                  <i></i>{{ deviceStatusLabel(device.status) }}
                </span>
              </p>
            </div>
            <button type="button" class="widget-map__open-device" *ngIf="canOpenDevice && !isPreview && !isMockPreview"
              (click)="openDevice(device)">
              <mat-icon>open_in_new</mat-icon>Ver dispositivo
            </button>
            <button type="button" class="widget-map__close" aria-label="Cerrar" (click)="closeDetail()">
              <mat-icon>close</mat-icon>
            </button>
          </header>

          <div class="widget-map__detail-body">
            <!-- Con variables elegidas: solo esas variables (las visibles), con su fecha -->
            <table *ngIf="usesVariables(device)">
              <thead><tr><th>Variable</th><th>Pos.</th><th>Valor</th></tr></thead>
              <tbody>
                <tr *ngFor="let value of visibleValues(device)" [class.widget-map__row--late]="value.status !== 'ok'">
                  <td>
                    <b><i class="widget-map__swatch" [style.background]="variableOf(value) ? variableColor(variableOf(value)!) : null"></i>{{ variableOf(value) ? variableLabel(variableOf(value)!) : '' }}</b>
                    <!-- Sin ningun dato ya lo dice la columna Valor: aqui solo la fecha del ultimo. Sin punto de
                         estado: el unico punto de la fila es el color de la variable (como en la leyenda y la cajita) -->
                    <small *ngIf="value.lastDate">{{ value.status === 'ok' ? '' : '⚠ ' }}último dato {{ ago(value.lastDate) }}</small>
                  </td>
                  <td class="widget-map__num">{{ value.position }}</td>
                  <td class="widget-map__num">{{ formatVariableValue(value) }}</td>
                </tr>
              </tbody>
            </table>

            <table *ngIf="!usesVariables(device)">
              <thead><tr><th>Pos.</th><th>Sensor</th><th>Valores</th></tr></thead>
              <tbody>
                <tr *ngFor="let row of rows(device)" [class.widget-map__row--late]="row.sensor.status !== 'ok'">
                  <td class="widget-map__num">{{ row.sensor.position }}</td>
                  <td>
                    <b>{{ row.typeLabel }}</b>
                    <small><i [style.background]="sensorColor(row.sensor.status)"></i>{{ row.sensor.lastDate ? 'último dato ' + row.ago : 'Sin datos' }}</small>
                  </td>
                  <td>
                    <div class="widget-map__value" *ngFor="let value of allValues(row.sensor)">
                      <span>{{ value[0] }}</span><span class="widget-map__num">{{ value[1] }}</span>
                    </div>
                    <span *ngIf="!allValues(row.sensor).length" class="widget-map__muted">—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </aside>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
